if (typeof ScrollingText !== "function") {
	class ScrollingText extends HTMLElement {
		constructor() {
			super();

			var ScrollingTextEngine = (function () {
				function getWidth(element) {
					var rect = element.getBoundingClientRect();
					return rect.right - rect.left;
				}

				function ScrollingTextEngine(box, speed) {
					var inner_element = (box.children && box.children[0]) || null;
					if (!inner_element) throw "No child node found";

					inner_element.style.position = "relative";

					this.position = 0;
					this.speed = speed;
					this.box = box;
					this.inner_element = inner_element.cloneNode(true);
					this._running = false;
					this._rafId = null;
					this._lastTime = null;
					this._direction = "ltr";

					refreshWidths.call(this);
					setUpChildrens.call(this);
				}

				function refreshWidths() {
					this.box_width = getWidth(this.box);
					this.inner_element_width = getWidth(this.box.children[0]);
				}

				function calculateNumElements() {
					if (!this.inner_element_width) return 1;
					return Math.ceil(this.box_width / this.inner_element_width) + 1;
				}

				function setUpChildrens() {
					var qty = calculateNumElements.call(this);
					if (qty > this.box.children.length) {
						for (var i = this.box.children.length; i < qty; i++) {
							this.box.appendChild(this.inner_element.cloneNode(true));
						}
					} else if (qty < this.box.children.length) {
						for (var i = qty; i < this.box.children.length; i++) {
							this.box.removeChild(this.box.lastChild);
						}
					}
				}

				function nextFrame(delta, direction) {
					var self = this;
					Array.prototype.forEach.call(this.box.children, function (el) {
						if (direction === "rtl") {
							el.style.right = -self.position + "px";
						} else {
							el.style.left = -self.position + "px";
						}
					});
					this.position += (this.speed * delta) / 1000;
					if (this.inner_element_width && this.position >= this.inner_element_width) {
						this.position = this.position % this.inner_element_width;
					}
				}

				ScrollingTextEngine.prototype = {
					start: function (direction) {
						if (this._running) return;
						this._running = true;
						this._direction = direction || this._direction || "ltr";
						this._lastTime = null;
						var self = this;

						var loop_func = function (now) {
							if (!self._running) return;
							var delta = self._lastTime === null ? 0 : now - self._lastTime;
							self._lastTime = now;
							nextFrame.call(self, delta, self._direction);
							self._rafId = window.requestAnimationFrame(loop_func);
						};

						this._rafId = window.requestAnimationFrame(loop_func);
					},

					stop: function () {
						this._running = false;
						if (this._rafId) {
							window.cancelAnimationFrame(this._rafId);
							this._rafId = null;
						}
					},

					refresh: function () {
						refreshWidths.call(this);
						setUpChildrens.call(this);
					}
				};

				return ScrollingTextEngine;
			})();

			const speed = window.innerWidth > 768
				? parseInt(this.dataset.scrollingSpeed, 10)
				: parseInt(this.dataset.scrollingSpeed, 10) / 1.5;
			const direction = this.dataset.scrollingDirection;
			const scrolling_text = new ScrollingTextEngine(this, speed);
			this._scrollingText = scrolling_text;

			var resizeTimer;
			window.addEventListener("resize", () => {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(function () {
					scrolling_text.refresh();
				}, 200);
			});

			var startMarquee = () => scrolling_text.start(direction);
			var stopMarquee = () => scrolling_text.stop();

			if ("IntersectionObserver" in window) {
				var visibilityObserver = new IntersectionObserver(function (entries) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							startMarquee();
						} else {
							stopMarquee();
						}
					});
				}, { rootMargin: "100px 0px" });
				visibilityObserver.observe(this);
			} else {
				startMarquee();
			}

			if (this.dataset.pauseOnHover === "true") {
				this.addEventListener("mouseenter", stopMarquee);
				this.addEventListener("mouseleave", startMarquee);
			}
		}
	}

	if (typeof customElements.get("scrolling-text") === "undefined") {
		customElements.define("scrolling-text", ScrollingText);
	}
}
